import { graphql } from "react-relay";
import { TailoredDefragSummaryAttendees } from "./TailoredDefragSummaryAttendees";

export const fragments = {
  org: graphql`
    fragment TailoredDefragSummaryAttendeeStats_org on Org {
      ...TailoredDefragSummaryAttendees_org
    }
  `,
  tailoredDefragCardSummary: graphql`
    fragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {
      defragTime
      impactedOtherCalendarIds
      valueStrings
      yourEventMoves {
        newStartTime {
          dateOrDateTime
        }
        originalStartTime {
          dateOrDateTime
        }
        moveReasons
        event {
          title
          calendarIds
        }
      }
      calendarValueStrings {
        calendarId
        valueStrings
      }
      persons {
        __typename
        ... on PersonList {
          ...TailoredDefragSummaryAttendees_personList
          list {
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  `,
};
